import EntityParameters from './EntityParameters.container'
export default EntityParameters
